export interface IJobUsersDetails {
    AvgLatency?: number;
    CompletionQty?: number;
    QtyBreakDownByType?: Record<string, number>; // Assuming QtyBreakDownByType is an object with string keys and number values
    AvgLatencyByType?: Record<string, number>; // Assuming AvgLatencyByType is an object with string keys and number values
    Rating?: number;
    Accuracy?: number;
}

export enum IJobUserDetailsActionTypes {
    FETCH_USER_DETAILS_FOR_JOB_REQUEST = 'FETCH_USER_DETAILS_FOR_JOB_REQUEST',
    FETCH_USER_DETAILS_FOR_JOB_SUCCESS = 'FETCH_USER_DETAILS_FOR_JOB_SUCCESS',
    FETCH_USER_DETAILS_FOR_JOB_FAILURE = 'FETCH_USER_DETAILS_FOR_JOB_FAILURE',
    
    UPDATE_USER_PROFESSIONAL_DETAILS_REQUEST = 'UPDATE_USER_PROFESSIONAL_DETAILS_REQUEST',
    UPDATE_USER_PROFESSIONAL_DETAILS_FAILURE = 'UPDATE_USER_PROFESSIONAL_DETAILS_FAILURE',
    UPDATE_USER_PROFESSIONAL_DETAILS_SUCCESS = 'UPDATE_USER_PROFESSIONAL_DETAILS_SUCCESS',

    UPDATE_USER_PERSONAL_DETAILS_REQUEST = 'UPDATE_USER_PERSONAL_DETAILS_REQUEST',
    UPDATE_USER_PERSONAL_DETAILS_FAILURE = 'UPDATE_USER_PERSONAL_DETAILS_FAILURE',
    UPDATE_USER_PERSONAL_DETAILS_SUCCESS = 'UPDATE_USER_PERSONAL_DETAILS_SUCCESS'
}



export type IJobUserDetailsActionCreator = {
    type?: string;
    payload?: IJobUsersDetails;
};
